var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTreeIcon = function SvgTreeIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 132.292 132.292",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    transform: "translate(0 .756)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66.146,
    cy: 27.895,
    r: 17.35,
    fillOpacity: 0.264,
    strokeLinecap: "square",
    strokeWidth: 7.785
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 16.404,
    cy: 109.689,
    r: 11.793,
    fillOpacity: 0.264,
    strokeLinecap: "square",
    strokeWidth: 5.292
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.742,
    cy: 109.689,
    r: 11.793,
    fillOpacity: 0.264,
    strokeLinecap: "square",
    strokeWidth: 5.292
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.544,
    cy: 70.152,
    r: 14.417,
    fillOpacity: 0.264,
    strokeLinecap: "square",
    strokeWidth: 6.469
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 6.615,
    d: "M20.41 99.408l6.237-15.875"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 6.615,
    d: "M44.592 99.196l-6.993-15.497"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.55,
    cy: 109.689,
    r: 11.793,
    fillOpacity: 0.264,
    strokeLinecap: "square",
    strokeWidth: 5.292
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.888,
    cy: 109.689,
    r: 11.793,
    fillOpacity: 0.264,
    strokeLinecap: "square",
    strokeWidth: 5.292
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.69,
    cy: 70.152,
    r: 14.417,
    fillOpacity: 0.264,
    strokeLinecap: "square",
    strokeWidth: 6.469
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 6.615,
    d: "M86.557 99.408l6.236-15.875"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 6.615,
    d: "M110.738 99.196l-6.993-15.497"
  })), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 6.615,
    d: "M41.026 59.067l13.63-17.507"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 6.615,
    d: "M90.47 57.864L76.707 41.56"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTreeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tree-icon.4b6352aa29b1ae30c2c1ee8aa7f6ad12.svg";